/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
export const protobufPackage = "injective.erc20.v1beta1";
function createBaseTokenPair() {
    return { bankDenom: "", erc20Address: "" };
}
export const TokenPair = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.bankDenom !== "") {
            writer.uint32(10).string(message.bankDenom);
        }
        if (message.erc20Address !== "") {
            writer.uint32(18).string(message.erc20Address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTokenPair();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bankDenom = reader.string();
                    break;
                case 2:
                    message.erc20Address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            bankDenom: isSet(object.bankDenom) ? String(object.bankDenom) : "",
            erc20Address: isSet(object.erc20Address) ? String(object.erc20Address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.bankDenom !== undefined && (obj.bankDenom = message.bankDenom);
        message.erc20Address !== undefined && (obj.erc20Address = message.erc20Address);
        return obj;
    },
    create(base) {
        return TokenPair.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTokenPair();
        message.bankDenom = object.bankDenom ?? "";
        message.erc20Address = object.erc20Address ?? "";
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
